import React from 'react';

const RelatedContent = ({ currentView, setCurrentView, theme }) => {
  // Map each page to related content
  const relatedContentMap = {
    "quiz-hub": [
      { view: "shopaholic-test", title: "Shopping Addiction Test" },
      { view: "shopping-personality-quiz", title: "Shopping Personality Quiz" },
      { view: "input", title: "Calculate Your Guilt" }
    ],
    "shopaholic-test": [
      { view: "shopping-addiction", title: "About Shopping Addiction" },
      { view: "emotional-spending-quiz", title: "Emotional Spending Quiz" },
      { view: "addiction-stories", title: "Recovery Stories" }
    ],
    "input": [
      { view: "dashboard", title: "Your Dashboard" },
      { view: "quiz-hub", title: "Take a Quiz" },
      { view: "blog", title: "Shopping Guilt Blog" }
    ],
    // Add mappings for other pages
  };

  const relatedLinks = relatedContentMap[currentView] || [];

  if (relatedLinks.length === 0) return null;

  const buttonStyles = {
    mint: "bg-emerald-100 text-emerald-700 hover:bg-emerald-200 dark:bg-emerald-900/30 dark:text-emerald-400",
    pink: "bg-pink-100 text-pink-700 hover:bg-pink-200 dark:bg-pink-900/30 dark:text-pink-400",
    lavender: "bg-purple-100 text-purple-700 hover:bg-purple-200 dark:bg-purple-900/30 dark:text-purple-400"
  };

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl p-4 mb-8">
      <h3 className="font-semibold mb-3 dark:text-white">Related Content</h3>
      <div className="flex flex-wrap gap-2">
        {relatedLinks.map(link => (
          <button
            key={link.view}
            onClick={() => setCurrentView(link.view)}
            className={`px-3 py-1.5 rounded-full text-sm ${buttonStyles[theme]}`}
          >
            {link.title}
          </button>
        ))}
      </div>
    </div>
  );
};

export default RelatedContent;
